<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ departamento.descricao }}</strong>
            </div>
        </b-card>
        <div class="d-flex justify-content-end align-items-end class mb-3">
            <b-button :id="'novoConfiguracaoDepartamentoLocal'" @click="showmodalSelecionarLocalArmazenamento()" size="sm">
                <b-icon icon="plus" />
                <b-tooltip :target="'novoConfiguracaoDepartamentoLocal'" title="Adicionar novo..."></b-tooltip>

            </b-button>
        </div>

        <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.localArmazenamentos"
                :fields="this.tableFields" :hover="true" show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>

                <template v-slot:cell(classificacao)="row">
                    {{ row.item.principal == 1 ? 'Central' : 'Secundário' }}
                </template>

                <template #cell(favorito)="row">
                    <b-button :id="row.index + 'favorito'" v-if="row.item.principal == 0"
                        @click="mudarFavorito(row.item)" size="sm">
                        <b-icon icon="star" />
                    </b-button>
                    <b-tooltip :target="row.index + 'favorito'" title="Tornar principal"></b-tooltip>

                </template>


                <template #cell(remover)="row">
                    <b-button :id="row.index + 'remover'" @click="remover(row.item)" size="sm">
                        <b-icon icon="trash" />
                        <b-tooltip :target="row.index + 'remover'" title="Remover"></b-tooltip>

                    </b-button>
                </template>

            </b-table>
        </b-card>
        <LgFinderPageLocalArmazenamentoModal v-if="modalSelecionarLocalArmazenamento" @close="fecharmodalSelecionarLocalArmazenamento"
            @onSelect="selecionarLocalArmazenamento" :prefix="prefix + title + ' > '"></LgFinderPageLocalArmazenamentoModal>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";

import LgFinderPageLocalArmazenamentoModal from "@/components/Modal/LgFinderPageLocalArmazenamentoModal.vue";

export default {
    components: {
        LgFinderPageLocalArmazenamentoModal
    },
    props: {
        departamento: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Localização",
        },
        currentSubgrupo: Object,
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "classificacao",
                    label: "Classificação",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "localArmazenamento",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "favorito",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "remover",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    data() {
        return {
            modalSelecionarLocalArmazenamento: false,
            localArmazenamentos: [],
            showModal: true,
            form: {
                classe: {},
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService('/api/departamento-local-armazenamento')

        this.load();
    },

    methods: {
        remover(item) {
            this.$removeResource(item);
            this.load();
        },
        async selecionarLocalArmazenamento(item) {
            var jaExiste = false;
            this.localArmazenamentos.forEach(localArmazenamento => {
                if (item.id == localArmazenamento.idLocalArmazenamento)
                    jaExiste = true;
            });

            if (jaExiste) {
                this.$notify({
                    type: "danger",
                    message: 'Esse registro já está cadastrado',
                });
                return;
            }

            try {

                this.busy = true;
                this.fecharmodalSelecionarLocalArmazenamento();
                var localArmazenamento = { localArmazenamento: item.id, principal: 0, situacao: 1, departamento: this.departamento };
                await this.$saveResource(localArmazenamento, "", false);
                this.busy = false;
                this.load();

            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: e.response.data,
                });
                this.busy = false;

            }
        },
        showmodalSelecionarLocalArmazenamento() {
            this.modalSelecionarLocalArmazenamento = true;
        },

        fecharmodalSelecionarLocalArmazenamento() {
            this.modalSelecionarLocalArmazenamento = false;
        },
        async load() {
            this.busy = true;

            var { data } = await this.$service.get(`localizacoes/${this.departamento.id}`);
            this.busy = false;
            this.localArmazenamentos = data;

        },
        async mudarFavorito(item) {
            let response = await this.$confirm(
                "Tem certeza que deseja mudar o departamento principal?"
            )
            if (response == true) {
                await this.$service.put(`principal/${item.id}/${this.departamento.id}`, {});
                this.load();
            }


        },


        cancelar() {
            this.$emit("close")
        },
    },

}
</script>